/* Zyora eLibrary – theme.js */
(function () {
  'use strict';

  // Sticky header shadow
  var hdr = document.querySelector('[data-hdr]');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('is-stuck', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Mobile menu
  var burger = document.querySelector('[data-burger]');
  var nav = document.querySelector('[data-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        burger.focus();
      }
    });
  }

  // Collection sort
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // Product page: gallery + variant switching
  var product = document.querySelector('[data-product]');
  if (product) {
    var stageImg = product.querySelector('.pd__stage img');
    product.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (stageImg) { stageImg.removeAttribute('srcset'); stageImg.src = btn.getAttribute('data-src'); }
        product.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
      });
    });

    var select = product.querySelector('[data-variants]');
    if (select) {
      var price = product.querySelector('[data-price]');
      var compare = product.querySelector('[data-compare]');
      var add = product.querySelector('[data-add]');
      var label = product.querySelector('[data-add-label]');
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        if (price) price.textContent = opt.getAttribute('data-price');
        if (compare) {
          var was = opt.getAttribute('data-compare');
          compare.textContent = was || '';
          compare.hidden = !was;
        }
        var ok = opt.getAttribute('data-available') === 'true';
        if (add) add.disabled = !ok;
        if (label) label.textContent = ok ? 'Add to cart' : 'Sold out';
        var url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url.toString());
      });
    }
  }
})();
